import {Component, effect, inject, input, model, output, untracked, viewChild} from '@angular/core';
import {RestApiService} from '../../services/api/rest-api.service';
import {Movie} from '../../models/vision/movie';
import {Dropdown, DropdownFilterEvent, DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-movie-selector',
  imports: [
    DropdownModule,
    FormsModule
  ],
  templateUrl: './movie-selector.component.html',
  styleUrl: './movie-selector.component.css'
})
export class MovieSelectorComponent {
  private readonly api = inject(RestApiService);
  protected allMovies: Movie[] = [];
  protected query = '';

  private movieSelector = viewChild<Dropdown>('movieSelector');

  selectedMovieId = model<number | undefined>(undefined);

  movieSelected = output<number>();

  autoClear = input(true);

  constructor() {
    effect(() => {
      const movieId = this.selectedMovieId();
      if (movieId) {
        this.movieSelected.emit(movieId);
        if (this.autoClear()) {
          untracked(() => {
            this.movieSelector()?.clear();
            this.query = '';
            this.allMovies = [];
          });
        }
      }
    });
  }

  async filterMovie(event: DropdownFilterEvent) {
    this.query = event.filter.toLowerCase();
    if (!this.query || this.query.length < 3) {
      this.allMovies = [];
      return;
    }
    const response = await this.api.movies.filter({
      searchText: this.query,
      pay1: true,
      pay2: true,
      pay3: true,
      svod: true,
      freeTv: true,
      librarySvod: true,
      libraryFreeTv: true,
    });
    this.allMovies = response.data.dataList;
  }
}
